<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Submission Confirmed</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">

  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    body {
      background-color: #f2f2f2;
      font-family: Arial, sans-serif;
    }

    .container {
      width: 75%;
      max-width: 670px;
      height: 515px;
      margin: 50px auto 0;
      display: flex;
      background: white;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      overflow: hidden;
    }

    .left {
      width: 30%;
      background-color: #00566A;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 20px;
    }

    .left img {
      width: 100px;
      margin-bottom: 15px;
    }

    .left p {
      font-size: 18px;
    }

    .right {
      width: 70%;
      padding: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .right h1 {
      font-size: 30px;
      margin-bottom: 20px;
    }

    .right p {
      font-size: 17px;
      margin-bottom: 30px;
      color: #555;
    }

    .btn {
      background-color: #00566A;
      color: white;
      padding: 12px 22px;
      border: none;
      cursor: pointer;
      font-size: 14px;
      width: fit-content;
    }

    .btn:hover {
      opacity: 0.85;
    }

    /* ✅ MOBILE RESPONSIVE */
    @media (max-width: 768px) {
      .container {
        flex-direction: column;
        width: 90%;
        height: auto;          /* let it expand naturally */
        margin: 30px auto;
      }

      .left {
        width: 100%;
        padding: 30px 20px;
      }

      .right {
        width: 100%;
        padding: 30px 20px;
      }

      .right h1 {
        font-size: 22px;
      }

      .right p {
        font-size: 15px;
      }

      .btn {
        font-size: 14px;
      }
    }
  </style>
</head>
<body>

  <div class="container">

    <!-- Left Black Section -->
    <div class="left">
      <img style="width: 25px; height: 25px;" src="/static/assets/img/dtf-assets/images/redesign/confirmation.png" alt="Confirmation Icon">
      <p>{{ 'DynamicPortal.SubmissionConfirmed' | translate }}</p>
    </div>

    <!-- Right White Section -->
    <div class="right">
      <h1 style="font-size: 40px; font-family: Arial, Helvetica, sans-serif;">{{ 'DynamicPortal.Thankyou' | translate }}</h1>
      <br>
      <p>{{ 'DynamicPortal.Contact' | translate }}</p>
      <button class="btn" (click)="backtohome()">{{ 'DynamicPortal.return' | translate }}</button>
    </div>

  </div>

  <br><br><br><br>

</body>
</html>